"use client";
import { HTMLProps, useEffect, useState } from "react";
import { cn } from "@/utils/helpers";
import { getLang, getPageKeys } from "@/utils/selectors";
import Button, { ButtonProps } from "@/components/common/Button";
import styles from "./Nav.module.css";

const pageKeys = getPageKeys();

export interface NavProps extends HTMLProps<HTMLDivElement> {
	onClick?: (event: any) => void;
	buttonProps?: ButtonProps
}

export default function Nav({
	onClick,
	buttonProps,
	className
} : NavProps) {
	const [activeKey, setActiveKey] = useState<string>();

	useEffect(() => {
		const newActiveKey = window.location.pathname.slice(1);
		setActiveKey(newActiveKey);
	}, []);

	return (
		<nav
			className={cn(
				styles.Nav,
				className
			)}
		>
			<ul
				className={styles.NavList}
			>
				{pageKeys.map(key =>
					<li
						key={key}
					>
						<Button
							pressed={(
								key === "map"
									? activeKey === ""
									: activeKey === key
							)}
							href={key === "map" ? "/" : `/${key}`}
							onClick={onClick}
							className={styles.NavListItemLink}
							{...buttonProps}
						>
							{getLang("page", key)}
						</Button>
					</li>
				)}
			</ul>
		</nav>
	);
}